import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

export const FeatureEntitlementManagementAccessConfig: DomainAccessControlConfig = {
  featureToggles: FeatureToggle.featureEntitlementsManagement,
  permissions: Permission.View,
}
